import styled from 'styled-components'

export const TemplateSelectWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  > div:first-child {
    flex: 0.5;
    min-width: 50%;
  }
`
